import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Padlock from '@wix/da-ds/pkg/Illustrations/Padlock';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BadgeAwardDescription from '../descriptions/BadgeAwardDescription';
import s from './SelectedBadgeAndDescription.scss';
const SelectedBadgeAndDescription = ({ className, selectedBadge, recipient, showLock })=>{
    const badgeImage = selectedBadge.badge.images[1];
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    const hideDescription = isMobile && showLock;
    const { imageUrl } = badgeImage || {};
    if (!imageUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['image'],
        loading: "lazy",
        src: imageUrl,
        alt: selectedBadge.badge.baseTitle
    }), showLock && /*#__PURE__*/ React.createElement("div", {
        className: s['lock']
    }, /*#__PURE__*/ React.createElement(Padlock, null)), selectedBadge.badge.campaignEnd && /*#__PURE__*/ React.createElement("div", {
        className: s['special-edition']
    }, t('coreBadge.badgeCard.specialEdition')), /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, selectedBadge.badge.baseTitle), !hideDescription && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement(BadgeAwardDescription, {
        awardableBadge: selectedBadge,
        user: recipient.user
    })));
};
SelectedBadgeAndDescription.displayName = 'SelectedBadgeAndDescription';
export default SelectedBadgeAndDescription;

//# sourceMappingURL=SelectedBadgeAndDescription.js.map